import { Component } from '@angular/core';

@Component({
    selector: 'aimo-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

}
